/* 🗝️ IAS · MODE PAINT — sitewide announcement-bar painter (Deck mode-pair law, 2026-10-10).
   The top bar's text is static theme config; this tiny global reader keeps it truthful to
   assets/ias-rates.json so the Oct 22 flip is ONE JSON edit: event mode in-window shows the
   event bar line, evergreen mode shows the evergreen line, and mode 'off' — or event mode
   outside its window — HIDES the Opening-Day bar entirely (never a stale promise).
   Anchored to the bar whose text already carries the campaign line; every other bar is
   untouched. Fails closed: any fetch miss = nothing changes. Wired in layout/theme.liquid
   via window.IAS_RATES_URL. */
(function () {
  'use strict';
  var u = window.IAS_RATES_URL;
  if (!u) return;
  function go() {
    fetch(u, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cfg) {
        if (!cfg) return;
        var msgs = document.querySelectorAll('.announcement-bar__message');
        var target = null;
        Array.prototype.forEach.call(msgs, function (m) {
          if (/Opening Day|Stack your chord|Stack keys/i.test(m.textContent)) target = m;
        });
        if (!target) return;
        var mode = cfg.mode, mb = cfg[mode] || {};
        var preview = /[?&]ias-ladder-preview=1/.test(location.search);
        var inWin = true;
        if (mode === 'event' && !preview) {
          var w = cfg.window || {}, n = Date.now();
          if (w.starts_at && n < Date.parse(w.starts_at)) inWin = false;
          if (w.ends_at && n > Date.parse(w.ends_at)) inWin = false;
        }
        if (mode === 'off' || !inWin || !mb.bar) {
          var bar = target.closest('.announcement-bar') || target;
          bar.style.display = 'none';
          return;
        }
        if (target.textContent.trim() !== mb.bar) {
          var holder = target.querySelector('span') || target;
          holder.textContent = mb.bar;
        }
      })
      .catch(function () {});
  }
  if (document.readyState !== 'loading') go();
  else document.addEventListener('DOMContentLoaded', go);
})();
